import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';

import Marker from 'react-google-maps/lib/components/Marker';

// Config
import config from '../../config';

import pinIcon from './assets/pin-green.svg';
import pinIconDisabled from './assets/pin-green_dis.svg';

class RestaurantGoogle extends Component {
  static defaultProps = {};

  static propTypes = {
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    metro: PropTypes.string.isRequired,
    pay_params: PropTypes.object,
    areas_details: PropTypes.array,
    coordinates: PropTypes.array.isRequired,
    onClick: PropTypes.func.isRequired,
    redirected: PropTypes.bool,
  };

  handleClick = () => {
    this.props.onClick();
  };

  render() {
    const { coordinates, redirected } = this.props;

    const markerCoords = new google.maps.LatLng(
      parseFloat(coordinates[1]),
      parseFloat(coordinates[0]),
    );

    return (
      <Marker
        position={markerCoords}
        icon={redirected ? pinIconDisabled : pinIcon}
        draggable={false}
        onClick={this.handleClick}
      />
    );
  }
}

export default RestaurantGoogle;
